/*
 * Formats a root brand social networks string into english.
 */
import {SOCIAL_NETWORKS} from "@/app/utils/SocialNetworks";

export default function(socialNetworks) {
    var ans = "";
    if (socialNetworks) {
        var a = socialNetworks.split(' ');
        for (var i = 0; i < a.length; i++) {
            if (i > 0) {
                if (i == a.length - 1) ans += " and ";
                else ans += ", ";
            }
            var code = a[i];
            var name = SOCIAL_NETWORKS[code];
            ans += name ? name : code
        }
    }
    return ans;
}